<template>
  <div class="home">
    <img src="@/assets/keyun.png" class="item-entry" @click="selectClass('keyun')">
    <img src="@/assets/huoyun.png" class="item-entry" @click="selectClass('huoyun')">
    <img src="@/assets/kehuoyun.png" class="item-entry" @click="selectClass('kehuoyun')">
    <img src="@/assets/weihuo.png" class="item-entry" @click="selectClass('weihuo')">

<!--    <div class="btn-item" @click="selectClass(36551)">-->
<!--      36551-->
<!--    </div>-->
<!--    <div class="btn-item" @click="selectClass(36552)">-->
<!--      36552-->
<!--    </div>-->
<!--    <div class="btn-item" @click="selectClass(36653)">-->
<!--      36653-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  name: 'Home',
  methods: {
    selectClass(courseId) {
      this.$router.push({path: '/course', query: {cid: courseId}})
    }
  }
}
</script>
<style lang="scss" scoped>
.home {
  padding: 0 40px;
  max-width: 1200px;
  min-width: 850px;
  margin: 0 auto;
  .item-entry {
    display: block;
    width: 800px;
    height: auto;
    margin-top: 50px;
    margin-left: auto;
    margin-right: auto;
    cursor: pointer;
  }
}
</style>
